module.exports = __webpack_public_path__ + "img/avatar1.0ebf049e.png";